import { api } from '@services';
import { Convert } from '@utils';

const generateType = (actionType = 'CUSTOM', reducer = 'PAGE/ADMINNEWS') => `${reducer}/${actionType}`;

export const fetchAll = () => {
	return async (dispatch, getState) => {
		const { board } = getState().page.adminNews;
		const { from, size } = board;

		const onOK = async (res) => {
			const $list = res.info.data || [];
			const total = res.info.count || [];

			await dispatch({
				type: generateType('CUSTOM'),
				payload: {
					...getState().page.adminNews,
					board: {
						...getState().page.adminNews.board,
						total,
						$list,
					},
				},
			});
		};

		const onStatus = async (status) => {
			await dispatch({
				type: generateType('CUSTOM'),
				payload: {
					...getState().page.adminNews,
					board: {
						...getState().page.adminNews.board,
						_list: status,
					},
				},
			});
		};

		const onFail = async (res) => {
			await dispatch({
				type: generateType('CUSTOM'),
				payload: {
					...getState().page.adminNews,
					board: {
						...getState().page.adminNews.board,
						$list: [],
					},
				},
			});
		};

		api.$news_fetchAll({ onOK, onStatus, onFail }, { from, to: from + size - 1 });
	};
};

export const fetchById = (id) => {
	return async (dispatch, getState) => {
		const onOK = async (res) => {
			const activeFrom = res.info.ACTIVEFROMGREGORIAN || '';
			const activeTo = res.info.ACTIVETOGREGORIAN || '';
			const title = res.info.TITLE || '';
			const date = res.info.CREATIONDATE || '';
			const content = res.info.CONTENT || '';
			const image = res.info.IMAGE || '';
			const isVisible = res.info.ISVISIBLE || '';

			await dispatch({
				type: generateType('CUSTOM'),
				payload: {
					...getState().page.adminNews,
					edit: {
						...getState().page.adminNews.edit,
						activeFrom,
						activeTo,
						content,
						title,
						image,
						date,
						isVisible: isVisible === 'Y' ? { name: 'منتشر شده', type: 'Y' } : { name: 'پیش نویس', type: 'N' },
					},
				},
			});
		};

		const onStatus = async (status) => {
			await dispatch({
				type: generateType('CUSTOM'),
				payload: {
					...getState().page.adminNews,
					edit: {
						...getState().page.adminNews.edit,
						_status: status,
					},
				},
			});
		};

		const onFail = async (res) => {
			await dispatch({
				type: generateType('CUSTOM'),
				payload: {
					...getState().page.adminNews,
					edit: {
						...getState().page.adminNews.edit,
						activeFrom: '',
						activeTo: '',
						content: '',
						title: '',
						image: '',
						date: '',
						isVisible: 'Y',
					},
				},
			});
		};

		api.$news_fetchById({ onOK, onStatus, onFail }, { id: Number(id) });
	};
};

export const addNews = () => {
	return async (dispatch, getState) => {
		const { activeFrom, activeTo, title, isVisible, content, image } = getState().page.adminNews.add;

		const onOK = async (res) => {
			await dispatch({
				type: generateType('CUSTOM'),
				payload: {
					...getState().page.adminNews,
					render: 'board',
				},
			});
		};

		const onStatus = async (status) => {
			await dispatch({
				type: generateType('CUSTOM'),
				payload: {
					...getState().page.adminNews,
					add: {
						...getState().page.adminNews.add,
						_status: status,
					},
				},
			});
		};

		const onFail = async (res) => {
			await dispatch({
				type: generateType('CUSTOM'),
				payload: {
					...getState().page.adminNews,
				},
			});
		};

		api.$news_save(
			{ onOK, onStatus, onFail, showOkMessage: true },
			{
				title,
				content,
				image,
				activefrom: Convert.newDateToFaDate(activeFrom),
				activeto: Convert.newDateToFaDate(activeTo),
				isvisible: isVisible.type,
			},
		);
	};
};

export const updateNews = () => {
	return async (dispatch, getState) => {
		const id = getState().page.adminNews.id;
		const { activeFrom, activeTo, title, isVisible, content, image } = getState().page.adminNews.edit;

		const onOK = async (res) => {
			await dispatch({
				type: generateType('CUSTOM'),
				payload: {
					...getState().page.adminNews,
					render: 'board',
					id: '',
				},
			});
		};

		const onStatus = async (status) => {
			await dispatch({
				type: generateType('CUSTOM'),
				payload: {
					...getState().page.adminNews,
					edit: {
						...getState().page.adminNews.edit,
						_status: status,
					},
				},
			});
		};

		const onFail = async (res) => {
			await dispatch({
				type: generateType('CUSTOM'),
				payload: {
					...getState().page.adminNews,
				},
			});
		};

		api.$news_edit(
			{ onOK, onStatus, onFail, showOkMessage: true },
			{
				id,
				title,
				content,
				image,
				activefrom: Convert.newDateToFaDate(activeFrom),
				activeto: Convert.newDateToFaDate(activeTo),
				isvisible: isVisible.type,
			},
		);
	};
};

export const deleteNews = () => {
	return async (dispatch, getState) => {
		const id = getState().page.adminNews.id;

		const onOK = async (res) => {
			await dispatch({
				type: generateType('CUSTOM'),
				payload: {
					...getState().page.adminNews,
					id: '',
					board: {
						...getState().page.adminNews.board,
						deleteModal: false,
					},
				},
			});

			await dispatch(fetchAll());
		};

		const onStatus = async (status) => {
			await dispatch({
				type: generateType('CUSTOM'),
				payload: {
					...getState().page.adminNews,
					board: {
						...getState().page.adminNews.board,
						_deleteModal: status,
					},
				},
			});
		};

		const onFail = async (res) => {
			await dispatch({
				type: generateType('CUSTOM'),
				payload: {
					...getState().page.adminNews,
				},
			});
		};

		api.$news_delete(
			{ onOK, onStatus, onFail, showOkMessage: true },
			{
				id,
			},
		);
	};
};
